module.exports = __webpack_public_path__ + "img/groomers_choice-1OikH5e.svg";